import React, { useRef, useState, useEffect, useContext } from "react";
import AudioVol from "./AudioVol";
import MyContext from "../../../context/MyContext";
import AudioTrack from "./AudioTrack";
import AuthContext from "../../../context/userAuth.context";
import MoveDownIcon from '@mui/icons-material/MoveDown';
import ProjectContext from "../../../context/ProjectContext";

var flag = false;
var Vstart, Vend, Vcurr, Vchange, staringPoint;

export const AudioPop = (props) => {
  const { LayersData, setLayersData,setpopShow } = useContext(MyContext);
  const value = props.value;
  const myaudio = useRef();
  const audioref = useRef();
  const { authenticationData, Role } = useContext(AuthContext);
  const {
    slides,
    setslides
  } = useContext(ProjectContext);

  const deleteFun = (key) => {
    var array = Array.from(LayersData);
    let changeArray = array.filter(function (value, index, arr) {
      if (value.key !== key) {
        return value;
      }
    });
    setLayersData(changeArray);
  };

  const [ParentTop, setParentTop] = useState(0);

  const [play, setplay] = useState(false);

  const [time, settime] = useState(0);

  const [curr_time, setcurr_time] = useState("00:00");

  const [width, setwidth] = useState(0);

  const [PositionX, setPositionX] = useState(0);

  const playaudio = (e) => {
    myaudio.current.play();

    setplay(true);
    settime(myaudio.current.duration);
  };

  const Stopaudio = (e) => {
    myaudio.current.pause();
    myaudio.current.currentTime = 0;
    setplay(false);
    setwidth(0);
    setcurr_time("00:00");
    setPositionX(0);
  };

  const AudioTimeChange = (e) => {
    var totalNumberOfSeconds = Math.round(e.target.currentTime);
    var hours = parseInt(totalNumberOfSeconds / 3600);
    var minutes = parseInt((totalNumberOfSeconds - hours * 3600) / 60);
    var seconds = Math.floor(
      totalNumberOfSeconds - (hours * 3600 + minutes * 60)
    );
    var result =
      (minutes < 10 ? "0" + minutes : minutes) +
      ":" +
      (seconds < 10 ? "0" + seconds : seconds);

    setcurr_time(result);

    var difference = 226 / time;

    var pixels = totalNumberOfSeconds * difference;

    setPositionX(Math.round(pixels));

    if (parseInt(width * (time / 100)) < e.target.currentTime) {
      setwidth(width + 1);
    }
  };

  const AudioEnd = (params) => {
    myaudio.current.pause();
    myaudio.current.currentTime = 0;
    setplay(false);
    setwidth(0);
    setcurr_time("00:00");
    setPositionX(0);
  };

  useEffect(() => {
    audioref.current.focus();
  }, []);

  return (
    <>
      <div className="" ref={audioref} tabIndex="0">
        <>
          <div className="OptInner">
            <div className="musicBox">


              <div className="musicBox_container">



                {props.popShow && slides.map((slide, index) =>
                  !slide.IsActive && (<div style={{ padding: "5px" }}><MoveDownIcon id={slide.key} onClick={(e) => {                  
                    const array = Array.from(LayersData);                    
                    for (var i in array) {
                      if (array[i].Editable == true && array[i].type == 'audio') {
                        var finalJson = JSON.parse(JSON.stringify(array[i]));
                        slides.filter(x=>x.key==e.currentTarget.id)[0].LayerData=slides.filter(x=>x.key==e.currentTarget.id)[0].LayerData.concat(finalJson);
                        setslides(slides);
                        //array[i].startPositionOnTimeline=0;
                        //array[i].startSound=0;
                        //setobjectsClipboard(array[i]);
                        array.splice(i, 1);
                        setpopShow(false);
                        break;
                      }
                    }

                    setLayersData(array);
                  }} className="toggleIconSettings" />{" Slide-" + (index + 1)}</div>)
                )}

                {!props.popShow &&
                  <div className="musixBoxDetail">
                    <audio
                      onEnded={AudioEnd}
                      ref={myaudio}
                      onTimeUpdate={AudioTimeChange}
                      src={authenticationData.ApiBaseURL + "/" + value.path}
                    />

                    <div className="musixBoxDetailHeader">
                      <div className="Music_name_container">
                        <div className="Music_name">FileName: {value.Name}</div>
                      </div>

                      <div className="Music_Action">


                        <div
                          className="Sound_delete_button"
                          onClick={() => {
                            deleteFun(value.key);
                          }}
                        >

                        </div>
                      </div>
                    </div>

                    <div className="MusicBox_player_container">
                      {play === false && (
                        <div className="MusicBox_play_Button" onClick={playaudio}>
                          <span className=" material-icons material-icons-outlined">
                            play_arrow
                          </span>
                        </div>
                      )}

                      {play === true && (
                        <div className="MusicBox_play_Button" onClick={Stopaudio}>
                          <span className=" material-icons">stop</span>
                        </div>
                      )}

                      <div className="Music_player_detail_container">
                        <AudioTrack
                          PositionX={PositionX}
                          setPositionX={setPositionX}
                          play={play}
                          setwidth={setwidth}
                          time={time}
                          AudioRef={myaudio}
                          value={value}
                          width={width}
                        />

                        <div className="audioStaus">
                          <div className="Music_Currtime">{curr_time}</div>
                          <div className="Music_fullLength">
                            {value.audioTime}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }

                {/* <AudioVol
                  play={play}
                  setLayersData={props.setLayersData}
                  LayersData={props.layersArray}
                  AudioRef={myaudio}
                  value={value}
                /> */}
              </div>
            </div>
          </div>
        </>
      </div>
    </>
  );
};
export default AudioPop;

// <div className="audioPopButtom" tabIndex="0" >
// <div className='aPopLabel'> Entire Animation</div>
// <div className='aPopCont'>
//     <div className="aPopVoice">
//         <div className='aPopIcon'>
//             <span className="material-icons material-icons-outlined">
//                 mic
//             </span>
//         </div>
//         <div className="aPopContent">
//             Add voiceover
//         </div>
//     </div>
//    <div className="aPopVoice">
//         <div className='aPopIcon'>
//             <span className="material-icons material-icons-outlined">
//                 mic
//             </span>
//         </div>
//         <div className="aPopContent">
//             Add music
//         </div>
//     </div>
// </div>
// </div>
// <div className="audioPopButtom" tabIndex="0" >
// <div className='aPopLabel'> Current Slide</div>
// <div className='aPopCont'>
//     <div className="aPopVoice">
//         <div className='aPopIcon'>
//             <span className="material-icons material-icons-outlined">
//                 mic
//             </span>
//         </div>
//         <div className="aPopContent">
//             Add voiceover
//         </div>
//     </div>
// </div>
// </div>
